import styled from 'styled-components'
import { Colors } from 'cio-design-library/design-tokens'
import Typography, { FontWeights } from 'builder/styles/typography'

export const Container = styled.div`
  min-width: 0;
  border-radius: 26px;
`
export const QuestionLabel = styled.div`
  color: ${Colors.Neutral50};
  ${FontWeights.Regular};
  ${Typography.Caption};
`

export const QuestionText = styled.div`
  color: ${Colors.Neutral100};
  ${FontWeights.Regular};
  ${Typography.Body};
`
